<template>
  <div class="Home">
    <div class="head">
      <div class="bodyTitle">
        <div class="pageTitle">视频汇聚</div>
      </div>
    </div>
    <div class="rela">
      <div class="relatitle" v-show="!showDialog">
        <div class="leftTop">
          <h2>{{ relatitle }}</h2>
        </div>
        <div class="checkBtns">
          <span
            :class="[index == targetBtn ? 'targetBtn' : '']"
            :key="index"
            @click="checkBtn(item, index)"
            v-for="(item, index) in btns"
          >{{ item }}</span>
        </div>
      </div>
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="item in num" :key="item ">
          <div v-if="item=='1'" class="relanews" v-show="!showDialog">
            <div class="part2">
              <div class="floor1">
                <ul class="floo1_left">
                  <li
                    :class="[index == target ? 'changes' : '']"
                    :key="index"
                    @click="playVideo(item)"
                    v-for="(item, index) in lists.slice(0, 8)"
                    v-on:mouseover="showChange(item, index)"
                  >
                    <img v-if="hasCheck=='1'" :src="item.imageLocal" alt class="tupian" />
                    <img v-else :src="imgUrl+item.imageLocal" alt class="tupian" />
                    <div class="details">
                      <h4 :class="[index == target ? 'change' : '']">{{ item.title }}</h4>
                    </div>
                    <div :class="[index == target ? 'changeto' : '']" class="jiatou">
                      <img alt src="../../assets/Starting/img-video/video_play.png" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-if="item=='2'" class="relanews" v-show="!showDialog">
            <div class="part2">
              <div class="floor1">
                <ul class="floo1_left">
                  <li
                    :class="[index == target ? 'changes' : '']"
                    :key="index"
                    @click="playVideo(item)"
                    v-for="(item, index) in lists.slice(8, 16)"
                    v-on:mouseover="showChange(item, index)"
                  >
                    <img v-if="hasCheck=='1'" :src="item.imageLocal" alt class="tupian" />
                    <img v-else :src="imgUrl+item.imageLocal" alt class="tupian" />
                    <div class="details">
                      <h4 :class="[index == target ? 'change' : '']">{{ item.title }}</h4>
                    </div>
                    <div :class="[index == target ? 'changeto' : '']" class="jiatou">
                      <img alt src="../../assets/Starting/img-video/video_play.png" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="popup" v-show="showDialog">
        <span @click="closeDialog" class="back iconfont icon-fanhui1"></span>
        <div class="prism-player" id="playerContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../untils/request";
import { getConvergence, monvideo } from "../../api/re";
export default {
  data() {
    return {
      source: "京开红窗口",
      relatitle: "",
      btns: ["宣传片", "抖音"],
      showDialog: false,
      today: "",
      nowTime: "",
      lists: [],
      count: 9,
      news: "",
      target: 0,
      target2: -1,
      currt: -1,
      videoLocal: "",
      videos: [],
      picPath: "",
      targetBtn: 0,
      hasCheck: "",
      num: null, //轮播页面数量
      numstime: "测试数据"
    };
  },
  computed: {
    imgUrl() {
      return "https://www.lsgcloud.com";
    }
  },
  created() {
    this.moon();
    this.websket();
     setInterval(()=>{
  this.numstime=JSON.parse(window.sessionStorage.getItem('numstime'))
   },50)
  },
  watch:{
      numstime: {
            handler(newName, oldName) {
               this.moon();
               this.numstime='测试数据';
             window.sessionStorage.setItem("numstime",JSON.stringify(this.numstime) );
            },

        }
  },
  methods: {
    websket() {
      // 检查浏览器是否支持SSE
      var supid = JSON.parse(window.sessionStorage.getItem("supid"));
      if ("EventSource" in window) {
        var source = new EventSource(
          // "http://192.168.31.206:40001/sse/connect/videoes"+supid
          "https://www.lsgcloud.com/sse/connect/videoes" + supid
        );
        source.onmessage = function(e) {

       if(e.data=='视频汇聚数据变动'){
         window.sessionStorage.setItem("numstime",JSON.stringify(e.data) );

         }

        };

        source.onopen = function(e) {
          //当连接正式建立时触发
          console.log("连接打开.");
        };

        source.onerror = function(e) {
          //当连接发生error时触发
          if (e.readyState == EventSource.CLOSED) {
            console.log("连接关闭");
          } else {
            console.log("onerror:" + e.readyState);
          }
        };
      } else {
        console.log("没有sse");
      }
    },
    playerInit() {
      var player = new Aliplayer(
        {
          id: "playerContent",
          source: this.videoLocal,
          width: "100%",
          height: "100%",
          autoplay: true,
          isLive: false,
          rePlay: false,
          playsinline: true, // H5是否内置播放
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true
        },
        () => console.log("The player is created")
      );
      this.player = player;
    },
    playVideo(item) {
      try {
        if (this.player) {
          this.player.dispose && this.player.dispose();
        }
      } catch (error) {}
      this.showDialog = true;
      if (this.hasCheck == 1) {
        this.videoLocal = item.videoLocal;
      } else {
        this.videoLocal = this.imgUrl + item.videoLocal;
      }

      this.picPath = item.picpath;
      let t = setInterval(() => {
        if (Aliplayer) {
          this.playerInit();
          clearInterval(t);
        }
      }, 500);
    },
    closeDialog() {
      this.showDialog = false;
      this.player.dispose();
    },

    //当前时间
    nowDate() {
      var now = new Date();
      this.today = now.Format("yyyy-MM-dd");
      this.nowTime = now.Format("hh:mm:ss");
    },
    //切换最新最热
    checkBtn(item, index) {
      this.targetBtn = index;
      if (item == "抖音") {
        this.hasCheck = 1;
        this.getVideo();
      } else if (item == "宣传片") {
        this.hasCheck = 2;
        this.source = "京开红窗口";
        this.moon();
      }
    },
    showChange(item, index) {
      this.target = index;
      this.target2 = -1;
      this.currt = -1;
    },
    change(list, index) {
      this.target = -1;
      this.target2 = -1;
      this.currt = index;
    },
    showChange2(item, index) {
      this.target = -1;
      this.target2 = index;
      this.currt = -1;
    },
    /*接口 */
    moon() {
      var supid = JSON.parse(window.sessionStorage.getItem("supid"));
      monvideo({
        title: "",
        tenantId: supid,
        pageNum: 1,
        pageSize: 10
      }).then(res => {
        this.lists = res.data.data.pageData;
        this.lond();
      });
    },
    getVideo() {
      getConvergence({
        "sourceList": [
          "中国消防",
          "山东消防",
          "天津消防",
          "乌鲁木齐消防",
          "南京消防",
          "湖北消防",
          "济宁消防",
          "扬州消防",
          "浙江消防",
          "山西消防",
          "江西消防"
        ]
      }).then(res => {
        this.lists = res.data.data;
        this.hasCheck = 1;
        this.lond();
      });
    },
    //轮播图处理方法,
    lond() {
      if (this.lists.length <= 10) {
        this.num = 1;
      } else if (this.lists.length > 10 && this.lists.length <= 20) {
        this.num = 2;
      } else if (this.lists.length > 20 && this.lists.length <= 30) {
        this.num = 3;
      } else if (this.lists.length > 30 && this.lists.length <= 40) {
        this.num = 4;
      } else if (this.lists.length > 40 && this.lists.length <= 50) {
        this.num = 5;
      }
    }
  }
};
</script>
<style >
.el-carousel__container {
  height: 35vh !important;
}
.el-carousel__indicators--outside {
  position: absolute !important;
}
</style>
<style lang="scss" scoped>
.Home {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/Starting/img-video/expert_bg_img.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // position: absolute;
  .head {
    margin: 0 3vw;
    display: flex;
    align-items: center;
    height: 11%;
    justify-content: space-between;
    user-select: none;
    position: relative;
    .bodyTitle {
      height: 7.4vh;
      font-size: 0.2vw;
      font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      left: -20px;
      img {
        width: 20px;
        height: 20px;
      }
      .img_monitor {
        transform: rotate(180deg);
      }
      .pageTitle {
        margin: 0 0.5em;
        white-space: nowrap;
      }
    }
  }
  .rela {
    width: 100%;
    height: 80%;
    margin: 0 auto;
    position: relative;
    z-index: 1000;
    .relatitle {
      z-index: 1000;
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .leftTop {
        h2 {
          color: #fff;
          display: inline-block;
          font-size: 1.1rem;
          position: relative;
          left: 20px;
          margin-right: 0.5rem;
          vertical-align: middle;
          font-family: PingFang-SC-Regular;
          font-weight: bold;
        }
        img {
          vertical-align: middle;
        }
      }
      .checkBtns {
        font-size: 0.3rem;
        color: #0072ff;
        position: absolute;
        right: 4%;
        span {
          width: 40px;
          height: 20px;
          display: inline-block;
          color: #3690fe;
          text-align: center;
          line-height: 20px;
          border-radius: 2px;
          cursor: pointer;
          margin-left: 6px;
        }
        span:hover,
        .targetBtn {
          border: 1px solid;
          color: #ffffff;
          border-image: linear-gradient(
              180deg,
              rgba(40, 157, 204, 1),
              rgba(129, 94, 255, 1)
            )
            10 10;
          background: linear-gradient(
            180deg,
            rgba(40, 157, 204, 1) 0%,
            rgba(129, 94, 255, 1) 100%
          );
        }
      }
    }
    .relanews {
      width: 100%;
      height: calc(100% - 40px);
      display: flex;
      .part1 {
        width: 10%;
        height: 100%;
        margin-right: 10px;
        .top {
          width: 100%;
          height: calc((100% - 10px) / 2);
          margin-bottom: 10px;
          background-color: #000000;
          li {
            cursor: pointer;
            width: 100%;
            height: 100%;
            position: relative;
            .tupian {
              width: 100%;
              height: 65%;
              object-fit: contain;
            }
            .details {
              padding: 7px;
              h4 {
                color: #fff;
                height: 8%;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 0.3rem;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                white-space: nowrap;
              }
              p {
                display: flex;
                font-size: 0.3rem;
                justify-content: space-between;
                align-items: center;
                margin-top: 7px;
                margin-bottom: 7px;
                .source {
                  display: inline-block;
                  text-align: left;
                  color: #70f4f6;
                  width: 100%;
                  font-size: 0.3rem;
                  font-family: MicrosoftYaHei;
                }
                .time {
                  display: inline-block;
                  text-align: right;
                  color: #70f4f6;
                  font-size: 0.3rem;
                  width: 3vw;
                  font-family: MicrosoftYaHei;
                }
              }
            }
            .jiatou {
              position: absolute;
              top: 10%;
              left: calc(50% - 17px);
              display: none;
            }
          }
        }
        .bottom {
          width: 100%;
          height: calc((100% - 10px) / 2);
          background-color: #000000;
          li {
            cursor: pointer;
            width: 100%;
            height: 100%;
            position: relative;
            .tupian {
              width: 100%;
              height: 65%;
              object-fit: contain;
            }
            .details {
              // padding: 7px;
              h4 {
                color: #fff;
                height: 8%;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 0.3rem;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                white-space: nowrap;
              }
              p {
                display: flex;
                justify-content: space-between;
                align-items: center;
                // margin-top: 7px;
                font-size: 0.3rem;
                margin-bottom: 7px;
                .source {
                  display: inline-block;
                  text-align: left;
                  color: #70f4f6;
                  font-size: 0.3rem;
                  width: 100%;
                  font-family: MicrosoftYaHei;
                }
                .time {
                  display: inline-block;
                  text-align: right;
                  color: #70f4f6;
                  width: 3vw;
                  font-size: 0.3rem;
                  font-family: MicrosoftYaHei;
                }
              }
            }
            .jiatou {
              position: absolute;
              top: 10%;
              left: calc(50% - 17px);
              display: none;
            }
          }
        }
      }
      .part2 {
        width: 100%;
        .floor1 {
          width: 100%;
          height: 95%;
          display: flex;
          .floo1_left {
            width: 95%;
            height: 100%;
            margin-right: 10px;
            display: flex;
            flex-wrap: wrap;
            // justify-content: space-around;
            align-items: center;
            margin: 0 auto;
            position: relative;
            left: 1.5%;
            li {
              margin: 2px;
              cursor: pointer;
              width: 23%;
              height: 48%;
              background-color: #000000;
              //   margin-bottom: 10px;
              position: relative;
              .tupian {
                width: 100%;
                height: 65%;
                object-fit: contain;
              }
              .details {
                height: 30%;
                position: relative;
                // top: -1vh;
                padding: 0.1vh;
                h4 {
                  color: #fff;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-size: 0.3rem;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                }
                p {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  // margin-top: 5px;
                  margin-bottom: 5px;
                  .source {
                    display: inline-block;
                    text-align: left;
                    color: #70f4f6;
                    font-size: 0.3rem;
                    width: 100%;
                    font-family: MicrosoftYaHei;
                  }
                  .time {
                    display: inline-block;
                    text-align: right;
                    color: #70f4f6;
                    font-size: 0.3rem;
                    width: 3vw;
                    font-family: MicrosoftYaHei;
                  }
                }
              }
              .jiatou {
                position: absolute;
                top: 10%;
                left: calc(50% - 17px);
                display: none;
              }
            }
            .changes {
              box-shadow: 0px 0px 2px 2px #1e489e;
              .change {
                color: #ffd801;
              }
              .changeto {
                display: block;
              }
            }
          }
          .floo1_right {
            width: 23%;
            height: 100%;
            background-color: #000000;
            li {
              cursor: pointer;
              width: 100%;
              height: calc(100% - 4px);
              position: relative;
              .tupian {
                width: 100%;
                height: 65%;
                object-fit: contain;
              }
              .details {
                padding: 7px;
                h4 {
                  color: #fff;
                  height: 8%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 0.3rem;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  white-space: nowrap;
                }
                p {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 7px;
                  margin-bottom: 7px;
                  .source {
                    display: inline-block;
                    text-align: left;
                    color: #70f4f6;
                    font-size: 0.3rem;
                    width: 100%;
                    font-family: MicrosoftYaHei;
                  }
                  .time {
                    display: inline-block;
                    text-align: right;
                    color: #70f4f6;
                    font-size: 0.3rem;
                    width: 3vw;
                    font-family: MicrosoftYaHei;
                  }
                }
              }
              .jiatou {
                position: absolute;
                top: calc(((100% - 56px) / 2) - 17px);
                left: calc(50% - 17px);
                display: none;
              }
            }
            .changes {
              box-shadow: 0px 0px 2px 2px #1e489e;
              .change {
                color: #ffd801;
              }
              .changeto {
                display: block;
              }
            }
          }
        }
        .floor2 {
          width: 75%;
          height: calc((100% - 10px) / 3);
          margin-top: 10px;
          ul {
            display: flex;

            width: 100%;
            height: 100%;
            .floor2_item {
              width: calc((100% - 10px) / 3);
              cursor: pointer;
              height: 100%;
              margin-right: 10px;
              background-color: #000000;
              position: relative;
              .img_container {
                position: relative;
                width: 100%;
                height: 65%;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
                .jiatou {
                  width: 40px;
                  height: 40px;
                  position: absolute;
                  top: calc(50% - 20px);
                  left: calc(50% - 20px);
                  display: none;
                }
              }
              .details {
                padding: 5px;
                h4 {
                  color: #fff;
                  height: 17px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 0.3rem;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                }
                p {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 5px;
                  margin-bottom: 5px;
                  .source {
                    display: inline-block;
                    text-align: left;
                    color: #70f4f6;
                    font-size: 0.3rem;
                    width: 100%;
                    font-family: MicrosoftYaHei;
                  }
                  .time {
                    display: inline-block;
                    text-align: right;
                    color: #70f4f6;
                    font-size: 0.3rem;
                    width: 3vw;
                    font-family: MicrosoftYaHei;
                  }
                }
              }
            }
            .changes {
              box-shadow: 0px 0px 2px 2px #1e489e;
              h4 {
                color: #ffd801;
              }
              .jiatou {
                display: block;
              }
            }
          }
        }
      }
    }
    .popup {
      width: 95%;
      height: 100%;
      position: absolute;
      top: 5%;
      left: 2%;
      z-index: 100;
      .back {
        position: absolute;
        top: -27px;
        right: 3px;
        display: inline-block;
        width: 20px;
        height: 24px;
        line-height: 26px;
        font-size: 0.2rem;
        text-align: center;
        cursor: pointer;
        color: #fff;
        background-color: #0e1e56;
        z-index: 999;
      }
      #playerContent {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
